import {
	ClozeDropdown,
	ImageLabeling,
	StudentAnswer,
} from '@mission.io/question-toolkit'
import { QuestionProps } from '@mission.io/question-views'

export type StudentResponse<
	T extends StudentAnswer = StudentAnswer
> = QuestionProps.StudentResponse<T>
export type ClassResponse = QuestionProps.ClassResponse

// Question Variations
export enum QuestionVariant {
	FREE_RESPONSE = 'FREE_RESPONSE',
	MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
	MULTIPLE_SELECT = 'MULTIPLE_SELECT',
	CLOZE_DROPDOWN = 'CLOZE_DROPDOWN',
	IMAGE_LABELING = 'IMAGE_LABELING',
}

export type DropdownClozeDropdown = ClozeDropdown['dropdowns'][number]

export type DropdownImageLabeling = ImageLabeling['dropdowns'][number]

export type Dropdown = DropdownClozeDropdown | DropdownImageLabeling
